import { throttle } from './utils';

const maxOpacity = 0.75;
const topOffset = 200;
const mobileSize = 425;
const VIDEO_SRC = "/assets/video/background_paint_loop_hq.mp4";

export default class Video {

    constructor(selector) {
        this.container = document.querySelector(selector);
        this.elem = this.container.querySelector('.bg-cover');
        this.video = this.container.querySelector('video');
    }

    init() {
        // this.setupListeners.bind(this)();
        window.addEventListener('resize', this.onWindowResize.bind(this));
        if (!isMobile()) {
            this.loadVideo.bind(this)();
        }
    }

    loadVideo() {
        this.video.src = VIDEO_SRC;
    }

    setupListeners() {
        this.maxScroll = window.innerHeight * 0.5;
        window.addEventListener('scroll', this.onScroll.bind(this))

        setTimeout(this.onScroll.bind(this), 100);
    }

    onWindowResize() {
        this.maxScroll = window.innerHeight * 0.5;
        if (!isMobile()) {
            this.video.src = VIDEO_SRC;
        }
    }

    onScroll() {
        const targetOpacity = Math.max(Math.min((window.scrollY - topOffset) / this.maxScroll, maxOpacity), 0);
        this.elem.style.opacity = targetOpacity;

    }
}

const isMobile = () => {
    return window.innerWidth <= mobileSize;
}


// WEBPACK FOOTER //
// ./assets/js/Video.js